<form (submit)="handleForm($event)">
  <div style="margin-bottom: 7px;">
    <div style="position: relative;">
      <div #paymentRequestButton class="applePayButton"></div>
      <!-- Overlay div when terms are not agreed -->
      <div *ngIf="!termsAgreementControl.value"
           (click)="onApplePayButtonClick()"
           style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; cursor: pointer;"></div>
    </div>

    <div class="st-elements-qbe">
      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="5px" style="margin-bottom: 5px;">
        <label fxFlex="50%" fxFlex.lt-sm="">
          <div class="st-label">Card</div>
          <div id="card-number-element" #cardNumberElement></div>
        </label>
        <label fxFlex="50%" fxFlex.lt-sm="">
          <div class="st-label">Exp</div>
          <div id="card-expiry-element" #cardExpElement></div>
        </label>
      </div>

      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="5px">
        <label fxFlex="50%" fxFlex.lt-sm="">
          <div class="st-label">CVC</div>
          <div id="card-cvc-element" #cardCvcElement></div>
        </label>
        <label fxFlex="50%" fxFlex.lt-sm="">
          <div class="st-label">Zip</div>
          <input id="postal-code" #cardPostalCode class="field-zip" mask="00000" placeholder="Zip"/>
        </label>
      </div>
    </div>

    <div id="card-element" #cardElement>
      <!-- A Stripe Element will be inserted here. -->
    </div>

    <!-- Used to display Element errors. -->
    <p class="has-text-danger">{{ cardErrors }}</p>
  </div>
  <hr>
  <div>
    <mat-checkbox [formControl]="termsAgreementControl"
                  color="primary"
                  labelPosition="after"
                  class="mat-checkbox-confirm"
    >
      <span (click)="onAgreementTextClick($event)"
            [innerHTML]="'form.checkout_agree_to_terms' | translate"></span>
      <mat-error *ngIf="termsAgreementControlError">{{ 'form.checkout_agree_to_terms_error' | translate }}</mat-error>
    </mat-checkbox>

    <mat-checkbox
      color="primary"
      labelPosition="after"
      class="brookfield-rules"
      *ngIf="kioskRules"
      value="true"
      [formControl]="kioskRulesControl"
    >
      By completing this transaction, you are agreeing to become a member of the risk purchasing group, Brookfield Properties Tenant Insurance Program LLC RPG (the “RPG”), as more fully described in the Operating Agreement and Joinder. Membership in the RPG shall be on a Class B basis and is limited to providing the right to apply for and purchase insurance offered by the RPG. This membership does not provide any rights to direct the management of the RPG or share in the profits, losses, or other financial interests of the RPG.  Completing this transaction shall serve as the execution of the Joinder as of the date of the submission.
      <mat-error *ngIf="kioskRulesControl?.invalid && kioskRulesControl?.touched">{{ 'form.checkout_agree_to_terms_error' | translate }}</mat-error>
    </mat-checkbox>

  </div>
  <div class="guarantee__btns-container" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="stretch">
    <button mat-button class="mat-btn" [disabled]="loading || disabledBtn || !kioskRulesControl.valid" [class.spinner]="loading">{{ 'total_premium.purchase' | translate }}</button>
    <button mat-button type="reset" class="mat-btn outline" [disabled]="loading" *ngIf="hasBackButton" (click)="decline()">{{ 'form.go_back' | translate }}</button>
  </div>
  <div class="loading-notify" *ngIf="loading">
    {{ 'disclosure.your_payment_is_processing' | translate }}
  </div>

</form>



<pre *ngIf="confirmation" style="max-width: 500px;">
  {{ confirmation | json }}
</pre>
